import { langService } from '@/core';
import toastify from 'toastify-js';
import { createApp } from 'vue';
import ToastifyComponent from '@/components/toastify/toastify.vue';
export default class Toast {
    get toastifyConfig() {
        return {
            duration: 6000,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true,
            close: true,
            offset: {
                y: 10,
            },
        };
    }
    success(options) {
        toastify(Object.assign(Object.assign(Object.assign({}, options), this.toastifyConfig), { className: 'toastify-success' })).showToast();
    }
    warning(options) {
        toastify(Object.assign(Object.assign(Object.assign({}, options), this.toastifyConfig), { className: 'toastify-warning' })).showToast();
    }
    error(options) {
        toastify(Object.assign(Object.assign(Object.assign({}, options), this.toastifyConfig), { className: 'toastify-error' })).showToast();
    }
    info(options) {
        toastify(Object.assign(Object.assign(Object.assign({}, options), this.toastifyConfig), { className: 'toastify-info' })).showToast();
    }
    getMessageFromResponse(response) {
        if (response.isAxiosError) {
            // Network Errors. This includes no internet etc.
            if (!response.response && response.message === 'Network Error') {
                return langService.trans('feedback.check_internet_connection');
            }
        }
        if (response.response) {
            // response is an error
            const error = response.response;
            const showCustomMessage = error.data && error.data.data && error.data.data.hasOwnProperty('customMessage') ? error.data.data.hasOwnProperty('customMessage') : false;
            if (error.status >= 500) {
                return langService.trans('feedback.server_error');
            }
            else if (error.status === 422) {
                return langService.trans('feedback.invalid_data');
            }
            else if (error.status === 403) {
                return langService.trans('feedback.forbidden');
            }
            else if (showCustomMessage) {
                return error.data.error.message;
            }
        }
        return langService.trans('feedback.server_error');
    }
    fromResponse(response, context = null) {
        var _a, _b, _c, _d, _e, _f;
        if (response.isAxiosError) {
            // Network Errors. This includes no internet etc.
            if (!response.response && response.message === 'Network Error') {
                this.error({ text: langService.trans('feedback.check_internet_connection') });
                return;
            }
        }
        if (response.response) {
            // response is an error
            const error = response.response;
            const showCustomMessage = ((_b = (_a = error.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.hasOwnProperty('customMessage')) ? error.data.data.hasOwnProperty('customMessage') : false;
            const customMessageType = ((_d = (_c = error.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.hasOwnProperty('customMessageType')) ? error.data.data.hasOwnProperty('customMessageType') : '';
            if (error.status >= 500) {
                // eslint-disable-next-line vue/one-component-per-file
                const component = createApp(ToastifyComponent, {
                    title: langService.trans('feedback.server_error'),
                });
                const el = document.createElement('div');
                component.mount(el);
                this.error({ node: el });
                // this.error({ text: langService.trans('feedback.server_error') });
            }
            else if (error.status === 429) {
                this.error({ text: langService.trans('feedback.too_many_attempts') });
            }
            else if (error.status === 422) {
                // TODO refactor toast into more vue like
                const errors = this.getValidationMessages((_f = (_e = error.data) === null || _e === void 0 ? void 0 : _e.error) === null || _f === void 0 ? void 0 : _f.errors, context);
                // eslint-disable-next-line vue/one-component-per-file
                const component = createApp(ToastifyComponent, {
                    title: langService.choice('validation-fields.has_errors', errors.length, { count: errors.length }),
                    messages: [...new Set(errors)], // remove duplicates
                });
                const el = document.createElement('div');
                component.mount(el);
                this.error({ node: el });
            }
            else if (showCustomMessage) {
                if (customMessageType === 'success') {
                    this.success({ text: error.data.error.message });
                }
                else if (customMessageType === 'warning') {
                    this.warning({ text: error.data.error.message });
                }
                else {
                    this.error({ text: error.data.error.message });
                }
            }
        }
    }
    getValidationMessages(errors, context = null) {
        const data = [];
        if (errors instanceof Object) {
            Object.keys(errors).forEach((key) => {
                data.push(this.getValidationMessage(key, errors, context));
            });
        }
        return data;
    }
    getValidationMessage(errorKey, errors, context = null) {
        if (errorKey === 'files' && errors[errorKey] && errors[errorKey][0]) {
            return errors[errorKey][0];
        }
        // filter numeric values
        const segments = errorKey.split('.').filter(value => isNaN(Number(value)));
        // find translation for specific field
        const field = this.getSpecificField(segments.join('.'), context);
        if (field) {
            // append field to error message
            const errorSentence = `${field} ${errors[errorKey][0].toLowerCase()}`;
            return this.capitalizeFirstLetter(errorSentence);
        }
        // fallback to generic error message
        return langService.trans('feedback.invalid_data');
    }
    getSpecificField(key, context = null) {
        if (context) {
            const translationKey = `validation-fields.${context}.${key}`;
            const specificField = langService.trans(translationKey);
            if (specificField && specificField !== translationKey) {
                return specificField;
            }
        }
        // try to find fallback field
        const translationFallbackKey = `validation-fields.common.${key}`;
        const specificFallbackField = langService.trans(translationFallbackKey);
        if (specificFallbackField && specificFallbackField !== translationFallbackKey) {
            return specificFallbackField;
        }
        return null;
    }
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
}
